import { render } from "./TabletMap.vue?vue&type=template&id=508d99b0"
import script from "./TabletMap.vue?vue&type=script&lang=js"
export * from "./TabletMap.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__